export default __webpack_public_path__ + "media/images/backgrounds/peach-vegetables-bg-592dd43821c3912ca2efdbcafc4871ec.svg";